import React from 'react';

import moment from 'moment';
import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import Field from 'redux-form/lib/Field';
import reduxForm from 'redux-form/lib/reduxForm';
import SubmissionError from 'redux-form/lib/SubmissionError';

import Button from 'reactstrap/lib/Button';
import Form from 'reactstrap/lib/Form';

import DateTimePickerAtom from 'atoms/DateTimePicker';


import { FILTER_FORM_LAYOUT } from 'constants/layout';

const CustomTimecardFilterFormComponent = (props, context) => {
  const { router: { history } } = context;
  const {
    dateFormat,
    location: { pathname, query },
    handleSubmit,
    error,
  } = props;
  const { page, ...rest } = query;


  const submit = data => {
    const detail = { ...data };
    if (detail.start_date && detail.end_date) {
      const formattedStartDate = moment(detail.start_date)
      const formattedEndDate = moment(detail.end_date)
      if (formattedStartDate > formattedEndDate) {
        const errObj = {
          _error: 'The Start date should be less than or equal to end date.',
        };
        throw new SubmissionError(errObj);
      }
    }
    const { page: pageNo, ...restDetail } = detail;
    restDetail.start_date = moment(data.start_date).format('YYYY-MM-DD');
    restDetail.end_date = moment(data.end_date).format('YYYY-MM-DD');
    cookie.save('startDate', restDetail.start_date, { path: '/' });
    cookie.save('endDate', restDetail.end_date, { path: '/' });

    history.push({
      pathname, search: queryString.stringify({ ...rest, ...restDetail }),
    });
  };

  return (
    <Form inline onSubmit={handleSubmit(submit)} className="report-filter date-filter-width">
      <Field
        id="start_date"
        name="start_date"
        placeholder="Start Date"
        component={DateTimePickerAtom}
        options={{ dateFormat }}
      />
      <Field
        id="end_date"
        name="end_date"
        placeholder="End Date"
        component={DateTimePickerAtom}
        options={{ dateFormat }}
      />
      <Button
        type="submit"
        color="accent"
        style={{ marginBottom: '24px'}}
        size={FILTER_FORM_LAYOUT.size}
        className="pr-4 pl-4"
      >
        Apply
      </Button>
      <div style={{ color: '#d9534f', marginTop: '-20px', 'font-size': '12px'}}>
        {error}
      </div>
    </Form>
  );
}

const validate = (values) => {
  const errors = {};
  if (!values.start_date) errors.start_date = 'Select Start Date';
  if (!values.end_date) errors.end_date = 'Select End Date';
  const formattedStartDate=moment(values.start_date).format();
  const formattedEndDate=moment(values.end_date).format();
  if(formattedStartDate > formattedEndDate) errors.start_date ='Start date should be less than end date.';
  return errors;
};

CustomTimecardFilterFormComponent.propTypes = {
  dateFormat: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([ PropTypes.array, PropTypes.string ]),
};

CustomTimecardFilterFormComponent.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default reduxForm({
  form: 'CustmTimecardFilterForm',
  validate,
  enableReinitialize: true,
})(CustomTimecardFilterFormComponent);
